import { Component, OnInit } from '@angular/core';
import { DataService } from '../../../services/data/data.service';
import { ExcelService } from '../../../services/excel/excel.service';
import Swal from 'sweetalert2';
import { Objetivos, obtenerError, Perspectivas, Planificacion, procesamiento, Responsables } from '../../../models/Formulacion/indicadores-metas/datos';
import { FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom, lastValueFrom } from 'rxjs';
import { messages } from '../../funciones/mensajes';
import moment from 'moment';
import { PlanificacionService } from '../../../services/gestion/planificacion/planificacion.service';
import { PerspectivaService } from '../../../services/gestion/perspectivas/perspectiva.service';
import { ObjetivoService } from '../../../services/gestion/objetivo/objetivo.service';
import { ResponsableService } from '../../../services/gestion/responsable/responsable.service';
import { PERMISOS } from '../../../shared/catalogos';

@Component({
  selector: 'app-objetivos',
  templateUrl: './objetivos.component.html',
  styleUrl: './objetivos.component.css'
})
export class ObjetivosComponent implements OnInit {
  public readonly permisos = PERMISOS;

  public planeacion: Planificacion[] = [];
  public perspectiva: Perspectivas[] = [];
  public objetivos: Objetivos[] = [];
  public responsable: Responsables[] = [];
  public Oobjetivos: any = []; //diccionarioObjetivos

  public idPers: number = 0; //para la perspectiva
  //public idObj: number = 0; //para el objetivo
  //public indic: any;
  //public pondera: number = 0;
  //public ponderaciontotal: number = 0;
  public objetivoo: any;
  public idPlanificacion: any;
  public viewTablero = false;
  public skeleton = ['','','',''];

  //public responsableSelect: any;
  public modal = false;
  public modal2 = false;


  /** Grupo de validación de datos */
  formNuevo = new FormGroup({
    inputName: new FormControl('', [Validators.required]),
    inputNameEdit: new FormControl('', [Validators.required]),
    inputPerspective: new FormControl('', [Validators.required]),
    inputPerspectiveEdit: new FormControl('', [Validators.required]),

    inputPonderacion: new FormControl('', []),
    inputPonderacionEdit: new FormControl('', []),
  }, { validators: this.nombreDuplicidad() });

  constructor(
    public dataService: DataService,
    private excelService: ExcelService,
    private cookies: CookieService,
    private translate: TranslateService,

    private planificacionService: PlanificacionService,
    private responsableService: ResponsableService,
    private objetivosService: ObjetivoService,
  ) {
    this.obtData();
  }

  ngOnInit(): void {
    // Initialization logic here
  }

  private ordenarPerspe(array: any) {
    array.sort(function (a: any, b: any) {
      if (Number(a.id) > Number(b.id)) {
        return 1;
      }
      if (Number(a.id) < Number(b.id)) {
        return -1;
      }
      return 0;
    });
    return array;
  }

  /** Obtención de datos */
  public async obtData() {
    try {
      //obtener el valor de las cookies
      const planeacionId = this.cookies.get('idInstitucion');
      const plan = await this.planificacionService.getPlanificacionByIdGQL(Number(planeacionId));

      if (!plan) return;

      this.planeacion = [{
        id: plan.id,
        nombre: plan.name,
        fecha_inicio: moment(plan.initial_date).toDate(),
        fecha_fin: moment(plan.end_date).toDate(),
        institucionId: plan.institution.id,
        isActive: plan.isActive
      }];

      this.idPlanificacion = parseInt(plan.id, 10); //conversion a number

      // Obtener responsables de la institución
      const responsables = await lastValueFrom(this.responsableService.getResponsable());
      this.responsable = [];
      for (const are of responsables) {
        if (are.institution.id === plan.institution.id) {
          for (const resp of are.responsibles) {
            this.responsable.push({
              id: resp.id,
              nombre: resp.position,
              cargo: resp.position,
            });
          }
        }
      }
      this.responsable = this.ordenarPerspe(this.responsable);

      // Obtener perspectivas de la planificación
      this.perspectiva = [];
      for (const per of plan.perspectives) {
        this.perspectiva.push({
          nombre: per.name,
          descripcion: per.description,
          planningId: plan.id,
          id: per.id,
        });
      }
      this.perspectiva = this.ordenarPerspe(this.perspectiva);

      // Inicializar Oobjetivos
      this.Oobjetivos = [];
      this.perspectiva.forEach(per => { this.Oobjetivos.push({ perspectivaaa: per, objetivosss: [] }); });

      // Obtener objetivos y asignarlos
      var objetivos = [];
      for(const per of this.perspectiva){
        const res = await this.objetivosService.getObjectivesByPerspectiveGQL(Number(per.id))
        objetivos = objetivos.concat(res);
      }
      this.obtObjetivos(objetivos);
      this.viewTablero = true;
    } catch (error) {

    }
  }

  private obtObjetivos(response) {
    this.objetivos = [];
    for (const per of this.Oobjetivos) {
      per.objetivosss = [];
      for (const obj of response) {
        if (obj.perspective.id === per.perspectivaaa.id) {
          per.objetivosss.push({
            nombre: obj.name,
            descripcion: obj.description,
            ponderacion: obj.weighing,
            perspectiveId: obj.perspective.id,
            responsableId: [{id: obj.responsibles[0].responsibleId}],
            id: obj.id
          });
          this.objetivos.push({
            nombre: obj.name,
            descripcion: obj.description,
            ponderacion: obj.weighing,
            perspectiveId: obj.perspective.id,
            responsableId: obj.responsibles[0].responsibleId,
            id: obj.id
          });
          per.objetivosss = this.ordenarPerspe(per.objetivosss);
        }
      }
    }
    this.objetivos = this.ordenarPerspe(this.objetivos);
  }

  /** Modal */
  // Abrir
  public open_modal(per: any) {
    this.idPers = per.id;
    this.formNuevo.controls['inputPerspective'].setValue('default'); //para que siempre se muestre la opcion por default
    this.modal = true;
  }

  public open_edit(ind: any, per: any) {
    this.objetivoo = ind;
    this.idPers = per.id;
    this.modal2 = true;
    this.formNuevo.controls['inputNameEdit'].setValue(this.objetivoo.nombre);
    for (const res of this.objetivoo.responsableId) {
      this.formNuevo.controls['inputPerspectiveEdit'].setValue(res.id);
    }
    this.formNuevo.controls['inputPonderacionEdit'].setValue(this.objetivoo.ponderacion);
  }

  // Cerrar
  public closeModal() {
    this.modal = false;
    this.modal2 = false;
    this.formNuevo.reset();
  }

  /** Metodo de comporbación de guardado */
  public puede_guardar() {
    var objetive = new Objetivos();
    objetive.nombre = this.formNuevo.controls['inputName'].value;
    const perspectivaValue = this.formNuevo.controls['inputPerspective'].value;

    if (objetive.nombre !== '' && perspectivaValue !== 'default' && this.formNuevo.controls['inputPerspective'].value !== '' && !this.nombreExiste()) {
      return ''
    }
    return 'w3-disabled'
  }
  public puede_guardarEdit() {
    var objetive = new Objetivos();
    objetive.nombre = this.formNuevo.controls['inputNameEdit'].value;
    if (objetive.nombre !== '' && this.formNuevo.controls['inputPerspectiveEdit'].value !== '' && !this.nombreExiste()) {
      return ''
    }
    return 'w3-disabled'
  }

  /** Guardado de datos */
  public async almacenarD() {
    messages.messageSaving(this.translate.instant('swal.agregandoInfo'),this.translate.instant('swal.espere'));
    const objetive = new Objetivos();
    objetive.nombre = this.formNuevo.controls['inputName'].value;
    objetive.ponderacion = document.getElementById('ponderacion')["value"];
    objetive.perspectiveId = Number(this.idPers);
    objetive.responsableId = [Number(this.formNuevo.controls['inputPerspective'].value)];

    if (objetive.nombre !== '' && objetive.responsableId !== undefined && objetive.ponderacion !== undefined) {
      try {
        const res = await lastValueFrom(this.objetivosService.postObjetivos(objetive));
        var objetivos = [];
        for(const per of this.perspectiva){
          const res = await this.objetivosService.getObjectivesByPerspectiveGQL(Number(per.id))
          objetivos = objetivos.concat(res);
        }
        this.obtObjetivos(objetivos);
        Swal.close();
        messages.succesMessageGraph(this.translate.instant('gestion.formulacion.objetivos.infoAgregada'));
      } catch (err) {
        let er = obtenerError.errorObt(err['error'].message);
        messages.errorMessageGraph(er);
      } finally {
        this.closeModal();
      }
    } else {
      messages.errorMessageGraph(this.translate.instant('gestion.formulacion.objetivos.formText10'));
    }
  }

  public async guardarEdit() {
    messages.messageSaving(this.translate.instant('swal.editandoInfo'),this.translate.instant('swal.espere'));
    this.objetivoo.nombre = this.formNuevo.controls['inputNameEdit'].value;
    this.objetivoo.responsableId = [Number(this.formNuevo.controls['inputPerspectiveEdit'].value)];
    this.objetivoo.ponderacion = document.getElementById('ponderacionedit')["value"];

    try {
      await lastValueFrom(this.objetivosService.patchObjetivos(this.objetivoo));
      var objetivos = [];
      for(const per of this.perspectiva){
        const res = await this.objetivosService.getObjectivesByPerspectiveGQL(Number(per.id))
        objetivos = objetivos.concat(res);
      }
      this.obtObjetivos(objetivos);
      Swal.close();
      messages.succesMessageGraph(this.translate.instant('gestion.formulacion.objetivos.infoActualizada'));
    } catch (err) {
      let er = obtenerError.errorObt(err['error'].message);
      messages.errorMessageGraph(er);
    } finally {
      this.closeModal();
    }
  }

  /** Eliminación de datos */
  public async eliminarele(ele: any) {
    messages.messageSaving(this.translate.instant('swal.eliminandoInfo'),this.translate.instant('swal.espere'));
    try {
      await lastValueFrom(this.objetivosService.deleteObjetivos(ele));
      var objetivos = [];
      for(const per of this.perspectiva){
        const res = await this.objetivosService.getObjectivesByPerspectiveGQL(Number(per.id))
        objetivos = objetivos.concat(res);
      }
      this.obtObjetivos(objetivos);
      Swal.close();
      messages.succesMessageGraph(this.translate.instant('gestion.formulacion.objetivos.infoEliminada'));
    } catch (err) {
      let er = obtenerError.errorObt(err['error'].message);
      messages.errorMessageGraph(er);
    }
  }


  /** Metodo de decición */
  public async alertas(aler: any, ele?: any) {
    if (aler === 'editar') {
      this.guardarEdit();
    } else if (aler === 'guardar') {
        this.almacenarD();
    } else if (aler === 'eliminar') {
      const result = await messages.confirmationSave(
        this.translate.instant('swal.confirmarEliminar'),
        `${ele.nombre}`,
        this.translate
      );
      if (result) {
        this.eliminarele(ele);
      }
    }
  }


  /** Ediciones desde tabla */
  public async edicionPond(Obj: any) {
    var inputValue = Obj.ponderacion, introdujo: any, guardo = false;
    var nombre = 'obj.name';

    introdujo = await Swal.fire({
      title: this.translate.instant('gestion.formulacion.objetivos.editPond'),
      text: "",
      input: 'number',
      inputValue: inputValue,
      confirmButtonColor: '#ff6b00',
      cancelButtonColor: '#B9B9BC',
      confirmButtonText: this.translate.instant('swal.acep'),
      cancelButtonText: this.translate.instant('swal.cerr'),
      showCancelButton: true,
      reverseButtons: true,
      customClass: {
        actions: 'aleema-swal-actions',
        confirmButton: 'aleema-swal-confirm',
        cancelButton: 'aleema-swal-cancel',
        input: 'aleema-swal-select'
      },
      inputValidator: (value) => {
        if (!value) {
          return this.translate.instant('gestion.formulacion.objetivos.formText11');
        }
        guardo = true;
        return '';
      }
    });

    if (guardo) {
      try {
        messages.messageSaving(this.translate.instant('acciones.actualizando'),this.translate.instant('acciones.espera'));
        Obj.ponderacion = Number(introdujo.value);
        await lastValueFrom(this.objetivosService.patchObjetivosPon(Obj));
        // const response = await lastValueFrom(this.objetivosService.getObjetivos());
        // this.obtObjetivos(response);
        Swal.close();
        messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
      } catch (err) {
        let er = obtenerError.errorObt(err['error'].message);
        messages.errorMessageGraph(er);
      }
    }
  }


  /* ponderación automatica equitativa */
  public async ponderacionAutomatica() {
    var ponder = 0;
    for (const per of this.Oobjetivos) {
      for (const obj of per.objetivosss) {
        if (obj.ponderacion !== 0 || obj.ponderacion !== null) {
          ponder++;
        }
      }
    }
    if (ponder !== 0) {
      const result = await messages.confirmationSave(
        this.translate.instant('gestion.formulacion.objetivos.confPond'),
        '',
        this.translate
      );
      if (result) {
        this.ponderarEquitativamente();
      }
    } else {
      this.ponderarEquitativamente();
    }
  }

  private async ponderarEquitativamente() {
    var ponderPerspectiva = Number((100 / this.Oobjetivos.length).toFixed(1));
    var i = 0, j = 0;

    try {
      for (const per of this.Oobjetivos) {
        if (100 > Number(ponderPerspectiva) * this.Oobjetivos.length && i === this.Oobjetivos.length - 1) {
          const decPer = Number((ponderPerspectiva - Number(ponderPerspectiva) * this.Oobjetivos.length).toFixed(1));
          ponderPerspectiva += decPer;
        } else if (100 < Number(ponderPerspectiva) * this.Oobjetivos.length && i === this.Oobjetivos.length - 1) {
          const decnPer = Number((Number(ponderPerspectiva) * this.Oobjetivos.length - 100).toFixed(1));
          ponderPerspectiva = Number((ponderPerspectiva - decnPer).toFixed(1));
        }

        var ponderObjetivo = Number((ponderPerspectiva / per.objetivosss.length).toFixed(1));

        for (const obj of per.objetivosss) {
          j++;
          obj.ponderacion = Number(ponderObjetivo);

          if (ponderPerspectiva > Number(ponderObjetivo) * per.objetivosss.length && j === per.objetivosss.length) {
            const dec = Number((ponderPerspectiva - Number(ponderObjetivo) * per.objetivosss.length).toFixed(1));
            obj.ponderacion += dec;
          } else if (ponderPerspectiva < Number(ponderObjetivo) * per.objetivosss.length && j === per.objetivosss.length) {
            const decn = Number((Number(ponderObjetivo) * per.objetivosss.length - ponderPerspectiva).toFixed(1));
            obj.ponderacion = Number((obj.ponderacion - decn).toFixed(1));
          }

          await lastValueFrom(this.objetivosService.patchObjetivosPon(obj));
        }
        j = 0;
        i++;
      }
      messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
    } catch (err) {
      let er = obtenerError.errorObt(err['error'].message);
      messages.errorMessageGraph(er);
    }
  }

  public clickFuera(event, modal) {
    if (event.target === document.getElementById(modal)) {
      document.getElementById(modal).classList.add('moveShake');
      setTimeout(() => {
        document.getElementById(modal).classList.remove('moveShake');
      }, 600);
    }
  }


  /** Exportación */
  public exportar_excel() {
    let subtitulosPerspectivas: any = [];
    let contenidoTabla: any = [];
    let headers: any = [];
    this.Oobjetivos.forEach((element: any) => {
      let contenidoObjetivos: any = [];
      subtitulosPerspectivas.push(element.perspectivaaa.nombre);
      headers.push(['#', 'Nombre', 'Peso']);
      element.objetivosss.forEach((obj: any, index: number) => {
        contenidoObjetivos.push(['O-'.concat((index + 1).toString()), obj.nombre, obj.ponderacion])
      });
      contenidoTabla.push(contenidoObjetivos);
    });
    this.excelService.generateExcelObjetivosFormulacion('Formulación: Objetivos', subtitulosPerspectivas, headers, contenidoTabla, 'formulación_objetivos')

  }

  /** Comprobación de que el nombre no exista*/
  private nombreDuplicidad(): ValidatorFn {
    return (formGroup: FormGroup) => {
      var nombre = ""
      if (this.modal) {
        nombre = this.formNuevo.controls['inputName'].value;
      } else if (this.modal2) {
        nombre = this.formNuevo.controls['inputNameEdit'].value;
      }
      nombre = nombre.trim();
      const existe = this.objetivos.find(element => {
        if (this.modal2) {
          return (procesamiento.procesamiento_Texto(element.nombre).toLowerCase() === nombre.toLowerCase() && element.id !== this.objetivoo.id);
        }
        return (procesamiento.procesamiento_Texto(element.nombre).toLowerCase() === nombre.toLowerCase());
      });
      if (existe) return { isValid: true };

      return null;
    };
  }
  public nombreExiste(): boolean {
    return this.formNuevo.hasError('isValid');
  }

}
